import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=24f23539&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"
import style0 from "./Developers.vue?vue&type=style&index=0&id=24f23539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f23539",
  null
  
)

export default component.exports